export enum BOQRoles {
  BOQ_OWN = 'BOQ_OWN',
  BOQ_ADMIN = 'BOQ_ADMIN',
  BOQ_CAT_ADMIN = 'BOQ_CAT_ADMIN',
}

export enum OrgRoles {
  ORG_OWN = 'ORG_OWN',
  ORG_ADMIN = 'ORG_ADMIN',
  ORG_FO = 'ORG_FO',
  ORG_FA = 'ORG_FA',
  ORG_MEMB = 'ORG_MEMB',
}

export enum ProjRoles {
  PROJ_MNGR = 'PROJ_MNGR',
  PROJ_MEMB = 'PROJ_MEMB',
  PROJ_PROF = 'PROJ_PROF',
  PROJ_PROC_OFF = 'PROJ_PROC_OFF',
  PROJ_CLI_BASE = 'PROJ_CLI_BASE',
  PROJ_CLI_APRV = 'PROJ_CLI_APRV',
}

export enum SiteRoles {
  SITE_ADMIN = 'SITE_ADMIN',
  SITE_MEMBER = 'SITE_MEMB',
  SITE_PROC_OFF = 'SITE_PROC_OFF',
  SITE_FIN_OFF = 'SITE_FIN_OFF',
  SITE_FLD_USR = 'SITE_FLD_USR',
  SITE_PROF = 'SITE_PROF',
  SITE_CLI_BASE = 'SITE_CLI_BASE',
  SITE_CLI_APRV = 'SITE_CLI_APRV',
}

export enum VCRoles {
  VC_SUPER = 'VC_SUPER',
  VC_DATA_STEWARD = 'VC_DATA_STEWARD',
  VC_PRICING_ADMIN = 'VC_PRICING_ADMIN',
  VC_STORE_MANAGER = 'VC_STORE_MANAGER',
  VC_COMPLIANCE_OFFICER = 'VC_COMPL_OFFICER',
}

export type Role = {
  id: number;
  name: string;
  code: SiteRoles | ProjRoles;
};
